import { render, staticRenderFns } from "./DashBoardGerenteArea.vue?vue&type=template&id=004bef29"
import script from "./DashBoardGerenteArea.vue?vue&type=script&lang=js"
export * from "./DashBoardGerenteArea.vue?vue&type=script&lang=js"
import style0 from "./DashBoardGerenteArea.vue?vue&type=style&index=0&id=004bef29&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports